import { render } from "./editOrganization.vue?vue&type=template&id=266cafbe"
import script from "./editOrganization.vue?vue&type=script&lang=js"
export * from "./editOrganization.vue?vue&type=script&lang=js"

import "./editOrganization.vue?vue&type=style&index=0&id=266cafbe&lang=less"
script.render = render

export default script